import React from 'react';
import {getTileStatusClass} from "../../../utils/adminStatus";
import {resolveBuybackPhotoUrl} from "../../../utils/adminMedia";

const MIDDLE_FIELD_KEYS = new Set([
    'buybackNumber',
    'device',
    'source',
    'status',
    'intakePurpose',
    'repair',
    'sale',
    'dealAt'
]);

const BuybackTile = ({row, visibleFields, actionColumn, buybackCurrency = 'CZK'}) => {
    const middleFields = (visibleFields || []).filter((field) => MIDDLE_FIELD_KEYS.has(field.key));
    const showPhoto = (visibleFields || []).some((field) => field.key === 'photo');
    const key = row._id || row.id || row.key;
    const purchasePrice = formatMoney(row?.economics?.purchasePrice, buybackCurrency);
    const salePrice = formatMoney(getLinkedSalePrice(row), buybackCurrency);
    const imageUrl = resolveBuybackPhotoUrl(row);

    return (
        <div key={key} className={`border rounded-lg bg-white shadow-sm overflow-hidden ${getTileStatusClass(row?.status) || 'border-gray-200'}`}>
            {showPhoto ? (
                <div className="aspect-[16/9] bg-gray-100">
                    {imageUrl ? (
                        <img src={imageUrl} alt={row?.buybackNumber || 'Výkup'} className="w-full h-full object-cover"/>
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-xs text-gray-500">
                            Bez fotografie
                        </div>
                    )}
                </div>
            ) : null}

            <div className="p-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 text-sm">
                    {middleFields.map((field) => (
                        <div key={field.key}>
                            <div className="text-gray-500 text-xs">{String(field.name || field.key)}</div>
                            <div>{field.renderCell ? field.renderCell({row}) : String(row?.[field.key] ?? '-')}</div>
                        </div>
                    ))}
                </div>

                <div className="mt-4 grid grid-cols-2 gap-3">
                    <div className="rounded-md border border-emerald-200 bg-emerald-50 p-2">
                        <div className="text-[11px] uppercase tracking-wide text-emerald-800">Výkup</div>
                        <div className="font-semibold text-emerald-900">{purchasePrice}</div>
                    </div>
                    <div className="rounded-md border border-indigo-200 bg-indigo-50 p-2 text-right">
                        <div className="text-[11px] uppercase tracking-wide text-indigo-800">Prodej</div>
                        <div className="font-semibold text-indigo-900">{salePrice}</div>
                    </div>
                </div>

                {actionColumn?.renderCell ? (
                    <div className="mt-3">
                        {actionColumn.renderCell({row})}
                    </div>
                ) : null}
            </div>
        </div>
    );
};

function getLinkedSalePrice(row) {
    const sale = row?.links?.saleOrderId;
    if (!sale || typeof sale !== 'object') return null;
    return sale.salePrice ?? null;
}

function formatMoney(value, currency = 'CZK') {
    if (value === null || value === undefined || value === '') return '-';
    const number = Number(value);
    if (!Number.isFinite(number)) return '-';
    return `${number.toLocaleString('cs-CZ')} ${currency}`;
}

export default BuybackTile;
